class NewsletterOffcanvas extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    // Selectors
    this.storeNameSelectors = ['input[placeholder="Punto vendita"]', 'input[placeholder="Store name"]'];

    // Triggers
    this.triggerForms = document.querySelectorAll('[data-nloc-form-trigger]');

    // Canvas elements
    this.offCanvas = document.querySelector('[data-nloc-offcanvas]');

    // Form elements
    this.formCt = this.element.querySelector('[data-nloc-form-ct]');
    this.form = this.formCt?.querySelector('form');
    this.email = this.form?.querySelector('input[type="email"]');
    this.focusTab = this.form?.querySelector('[data-nloc-autofocus]');
    this.storeName = this.element.querySelector('[data-nloc-storename]')?.dataset.nlocStorename || '';
    this.storeNameInput = '';
    this.isPopup = false;

    // Message
    this.messageContainer = this.element.querySelector('[data-nloc-message]');
    this.liveRegion = this.element.querySelector('[data-nloc-live]');

    // Trigger that opened the canvas (for focus restore)
    this.lastTrigger = null;

    // Handle Klaviyo
    this.klaviyoReady();

    if(this.offCanvas) {
      this.triggerFormHandler();
      this.handleCanvas();
    }
  }

  klaviyoReady() {
    console.clear();
    console.log(this.element.querySelector('form'));
    window.addEventListener('klaviyoForms', (e) => {
      console.log('klaviyoFormEvent: ', e);
      if (e.detail.type !== 'viewedStep') {
        return;
      }

      this.form = this.element.querySelector('form');
      console.log(this.form);
      this.email = this.form?.querySelector('input[type="email"]');
      if(this.form && this.storeName) {
        this.storeNameSelectors.forEach((selector) => {
          if(!this.storeNameInput) {
            this.storeNameInput = this.form.querySelector(selector);
          }
        });

        if(this.storeNameInput) {
          this.storeNameInput.value = this.storeName;
          this.storeNameInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.storeNameInput.readOnly = true;
        }
      }

      if(this.email) {
        this.element.dispatchEvent(new CustomEvent('sn:klaviyoReady'));

        if(!this.offCanvas) {
          setTimeout(() => {
            this.email.focus();
          }, 800);
        }
      }

      if(this.form) {
        this.handleSubmit();
      }
    });
  }

  triggerFormHandler() {
    this.triggerForms.forEach((trigger) => {
      let triggerInput = trigger.querySelector('input[type="email"]');

      trigger.addEventListener('submit', (event) => {
        this.isPopup = !!trigger.querySelector('[data-nloc-popup]');
        event.preventDefault();

        let email = '';
        if(triggerInput) {
          email = triggerInput.value;
        }

        this.openCanvas(email, trigger);
      });
    });
  }

  openCanvas(email = '', trigger = null) {
    this.offCanvas.classList.add('__show');
    this.lastTrigger = trigger;

    // Make the rest of the page inert while the modal is open.
    // Elements already inert (e.g. the desktop nav drawer) are left untouched.
    this.inertedChildren = [];
    Array.from(document.body.children).forEach((child) => {
      if (!child.contains(this.element) && !child.hasAttribute('inert')) {
        child.inert = true;
        this.inertedChildren.push(child);
      }
    });

    this.element.addEventListener('sn:klaviyoReady', () => {
      if(this.email) {
        this.email.value = email;
        this.email.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if(email) {
        this.focusTab = this.form?.querySelector('input[type="text"]');
      }
      else {
        this.focusTab = this.email;
      }

      if(this.focusTab) {
        setTimeout(() => {
          this.focusTab.focus();
        }, 800);
      }
    });
  }

  closeCanvas(refocus = false) {
    this.offCanvas.classList.remove('__show');

    (this.inertedChildren || []).forEach((child) => {
      child.inert = false;
    });
    this.inertedChildren = [];

    if (refocus && this.lastTrigger) {
      this.lastTrigger.focus();
    }
  }

  handleCanvas() {
    this.element.querySelectorAll('[data-nloc-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        // The close button restores focus; the backdrop does not.
        this.closeCanvas(el.tagName === 'BUTTON');
      });
    });

    document.addEventListener('keydown', (e) => {
      if(e.key == 'Escape') {
        this.closeCanvas(true);
      }
    });

    // Focus trap inside the open panel
    this.offCanvas.addEventListener('keydown', (e) => {
      if(e.key !== 'Tab' || !this.offCanvas.classList.contains('__show')) return;
      const focusable = Array.from(this.offCanvas.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'));
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  showMessage(type = 'error') {
    if(this.messageContainer) {
      if(this.liveRegion) {
        // Reset so that repeated messages are re-announced
        this.liveRegion.textContent = '';
      }
      // message already shown
      if(this.messageContainer.classList.contains('__success') || this.messageContainer.classList.contains('__missing') || this.messageContainer.classList.contains('__error')) {
        this.messageContainer.classList.add('__keep');
        this.messageContainer.classList.remove('__success');
        this.messageContainer.classList.remove('__missing');
        this.messageContainer.classList.remove('__error');

        setTimeout(() => {
          this.showMessage(type);
        }, 750);
      }
      else {
        if(type == 'success') {
          this.messageContainer.classList.add('__success');
          this.form.reset();
        }
        else if(type == 'missing')  {
          this.messageContainer.classList.add('__missing');
        }
        else {
          this.messageContainer.classList.add('__error');
        }
        this.messageContainer.classList.remove('__keep');

        if(this.liveRegion) {
          const message = this.messageContainer.querySelector('.__' + type + ' .alert');
          this.liveRegion.textContent = message ? message.textContent.trim() : '';
        }
      }
    }
  }

  handleSubmit(email = '') {
    this.form.addEventListener('submit', (event) => {
      if(email) {
        document.dispatchEvent(new CustomEvent('sn:newsletterSubscriptionSuccess', {
          detail: {
            email: email
          }
        }));
      }
      else {
        document.dispatchEvent(new CustomEvent('sn:newsletterSubscriptionSuccess'));
      }

      if(this.isPopup) {
        document.dispatchEvent(new CustomEvent('sn:newsletterPopupSubscription'));
      }
    });
  }
}

customElements.define("newsletter-offcanvas", NewsletterOffcanvas);
